import axios from "axios"

//const
const QUOTASUMMARY_GET = "initializeTenantSpace/QUOTASUMMARY_GET"
const INIT_TENANT_UPDATE_DATA = "initializeTenantSpace/INIT_TENANT_UPDATE_DATA"
const STORE_NAMESPACE = "initializeTenantSpace/STORE_NAMESPACE"
const HAS_NAMESPACE = "initializeTenantSpace/HAS_NAMESPACE"
const NAMESPACE_TOGGLE_MODAL = "initializeTenantSpace/NAMESPACE_TOGGLE_MODAL"

//reducer
export const initializeTenantSpace = (state = {
  quotaList:[],
  // months:1,
  // months:1
  name:"",
  rangeDate: [],
  namespace: "",
  hasNamespace: "",
  // password:"",
  // mysqlStorage:"",
  // databaseSize:"",
  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  messageInfo: {},
},action) => {
  switch (action.type) {
    case QUOTASUMMARY_GET:
      console.log("quota",action.data);
      return {
        ...state,
        quotaList: action.data
      };
    case INIT_TENANT_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case STORE_NAMESPACE:
      return {
        ...state,
        hasNamespace: true,
        namespace: action.data,
        [action.data.name]: action.data.value
      };
    case HAS_NAMESPACE:
      return {
        ...state,
        hasNamespace: false
      };
    case NAMESPACE_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    default:
      return state
  }
};
//actions

export const getQuotaSummary = () => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  return axios({
    method: "GET",
    url: `/api-tenant/org-quotas/?enterprise-code=`,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("QuotaSummary",response.data);
        dispatch(getQuotaSummaryDone(response.data))
      }
    })
};

/**
 * get all databaseNames
 */
export const getNamespace = (data) => (dispatch) => {
  let enterpriseId = data.enterpriseId === undefined?"00000000-0000-0000-0000-000000000000":data.enterpriseId;
  axios.get(`/api-tenant/namespace/getNamespace/`+ enterpriseId, {contentType: "application/json"})
    .then(
    response => {
       if (response.status === 200) {
         console.log(response.data);
         dispatch(storeNamespace(response.data));
       }
       else {
         dispatch(hasNamespace(false));
       }
    })
};




export const getQuotaSummaryDone = (data) => {
  return {
    type: QUOTASUMMARY_GET,
    data: data
  }
};
/**
 * get命名空间
 * @param data
 * @returns {{type: string, data: *}}
 */
export const storeNamespace = (data) => {
  return {
    type: STORE_NAMESPACE,
    data: data
  }
};
/**
 * 企业是否已经申请命名空间
 * @param data
 * @returns {{type: string, data: *}}
 */
export const hasNamespace = (data) => {
  return {
    type: HAS_NAMESPACE,
    data: data
  }
};

export const updateInitTenantData = (data) => {

  return {
    type: INIT_TENANT_UPDATE_DATA,
    data: data
    // "startDate": data.rangeDate[0],
    // "endDate": data.rangeDate[1],
  }
}



export const getQuotaDetail = () => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  return axios({
    method: "GET",
    url: `/api-tenant/org-quota/detail/kubernetes?quotaName= `,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("QuotaSummary",response.data);
        dispatch(getQuotaSummaryDone(response.data))
      }
    })
};

// export const getQuotaSummaryDone = (data) => {
//   return {
//     type: QUOTASUMMARY_GET,
//     data: data
//   }
// };

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: NAMESPACE_TOGGLE_MODAL,
    data: show
  }
};
